



















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import Header from '../Header.vue'
import RoomMemberList from '@/components/RoomMemberList.vue'
import PlayerGallarySelect from './PlayerGallarySelect.vue'
import PriorityRoleSelecter from './PriorityRoleSelecter.vue'
import ReadyModal from './ReadyModal.vue'
import Regulation from '@/components/Regulation.vue'

@Component({
  components: {
    Header,
    RoomMemberList,
    PlayerGallarySelect,
    PriorityRoleSelecter,
    Regulation,
    ReadyModal
  }
})

export default class Ready extends Vue {
  @Prop() game!: Game;
  @Prop() playerId!: string;
  @Prop() isGallary!: boolean;

  get self () {
    return this.game.getReadyPlayer(this.playerId)
  }

  get isGameMaster () {
    return this.game.masterId === this.self?.id && !this.isGallary
  }

  onTimeover () {
    if (!this.isGameMaster) return;

    this.game.setNextState()
  }
}
